@import "../../../global/gx-ide-common.scss";
@import "../../../global/gx-ide-mixins.scss";
@import "../../../global/temporary-tokens-chameleon.scss";

:host {
  display: block;
}

.header {
  display: grid;
  align-items: center;
  grid-template-columns: max-content 1fr min-content;
  gap: var(--spacing-gap-l);
}
.hidden-input {
  display: none;
}
